export const downpaymentInitialState = {
    fromAccount: undefined,
    toAccount: undefined,
    amount: undefined,
    currency: 'NOK',
    note: '',
    showFromAccounts: false,
    showToAccounts: false,
    paymentDate: undefined,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9Eb3ducGF5bWVudC9mb3JtL3N0YXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFBLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFxQjtJQUNyRCxXQUFXLEVBQUUsU0FBUztJQUN0QixTQUFTLEVBQUUsU0FBUztJQUNwQixNQUFNLEVBQUUsU0FBUztJQUNqQixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFO0lBQ1IsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixjQUFjLEVBQUUsS0FBSztJQUNyQixXQUFXLEVBQUUsU0FBUztDQUN6QixDQUFDIn0=